let lastExecutionTime = 0

function moreItemsWidth () {
  // swiper的最大宽度限制
  const swiperWrapper = document.querySelector('.StoreScanners__swiper-wrapper')
  const moreItemsWrapper = document.querySelector('.StoreScanners__more-items')
  if(moreItemsWrapper && swiperWrapper) {
    const rect = moreItemsWrapper.getBoundingClientRect()
    const gap = 20 + 19 + 10 // padding scroll-width 保险
    swiperWrapper.style.maxWidth = window.innerWidth - rect.left - rect.width - gap + 'px'
  }
}

function handleResize() {
  // 找到目标节点
  const MoreItem = $('.StoreScanners__more-item')
  // 找到商品元素
  const ProductItem = MoreItem && MoreItem.closest('.StoreScanners__body').find('.swiper-slide .StoreScanners__item')
  if(window.innerWidth <= 1200) {
    MoreItem.each(function () {
      $(this).width('100%')
    })
  }
  if (MoreItem?.length && ProductItem?.length && window.innerWidth > 1200) {
    // 获取商品元素的宽度
    const productWidth = ProductItem.eq(0).width()
    // 将目标元素的宽度设置为商品元素的宽度
    MoreItem.each(function () {
      $(this).width(productWidth)
    })

    moreItemsWidth()
  } else {
    console.log('没有找到 MoreItem 或 ProductItem')
  }
}

// 节流函数
function throttle(func, limit) {
  return function () {
    const now = Date.now()
    if (now - lastExecutionTime >= limit) {
      lastExecutionTime = now
      func()
    }
  }
}

// 使用节流函数
const throttledResize = throttle(handleResize, 300)

// 监听 resize 事件
window.addEventListener('resize', throttledResize)
moreItemsWidth()
